import { hostLabel } from "./format";

/**
 * 출처 URL 검사와 플랫폼 추정.
 *
 * P2: **출처 없는 제보는 없습니다.** 그래서 이 판정은 제보 화면의 제출 가능
 * 여부를 직접 정합니다 — Web 과 Native 가 다른 규칙을 쓰면 한쪽에서만 통과하는
 * 링크가 생깁니다. Web 제보 시트 안에 있던 것을 여기로 올렸습니다.
 *
 * OshiMap 은 원문을 복제하지 않고 **링크만** 보관합니다.
 */
export function isHttpUrl(v: string): boolean {
  const s = v.trim();
  if (!s) return false;
  try {
    const u = new URL(s);
    /* 점이 없는 호스트(localhost, 오타)는 출처가 될 수 없습니다. */
    return (u.protocol === "http:" || u.protocol === "https:") && u.hostname.includes(".");
  } catch { return false; }
}

/**
 * 링크로 만들어도 되는 주소만 돌려줍니다. 아니면 `null` 입니다.
 *
 * 저장된 출처 URL 을 그대로 `href` 에 넣지 않기 위해서입니다. 규칙이 세 곳에
 * 있었는데 서로 달랐습니다 — 수집(`safe_url`)과 후보 스키마(`publicUrl`)는
 * 자격 증명이 담긴 주소를 막는데, 제보 경로(`validate_url`)는 통과시켰습니다.
 * `https://naver.com@evil.example` 같은 주소가 출처로 붙을 수 있었습니다.
 *
 * 서버 쪽도 막았지만, **이미 저장된 것**이 있을 수 있으므로 그리는 자리에서
 * 한 번 더 봅니다. 스키마를 조이면 옛 줄 하나 때문에 화면 전체가 안 열립니다.
 */
export function safeHref(url: string): string | null {
  try {
    const u = new URL(url);
    if (u.protocol !== "http:" && u.protocol !== "https:") return null;
    if (u.username || u.password) return null;
    return url;
  } catch { return null; }
}

/** 모르는 곳은 `WEB` 입니다 — 추측한 플랫폼 이름을 지어내지 않습니다. */
export function guessPlatform(url: string): string {
  const h = hostLabel(url).toLowerCase();
  if (h.includes("x.com") || h.includes("twitter")) return "X";
  if (h.includes("instagram")) return "INSTAGRAM";
  if (h.includes("naver")) return "NAVER";
  if (h.includes("youtube")) return "YOUTUBE";
  return "WEB";
}
